<template>
  <b-field :class="name" :label="label"> 
    <b-select :value="currentValue" @input="set"  :placeholder="placeholder" :disabled="unclickable" expanded>
      <option value="">Selecione</option>
      <option
        v-for="item in items"
        :value="item.id"
        :key="item.id"
      >
      {{ item.name }}
      </option>
    </b-select>
  </b-field>
</template>

<script>
export default {
  name: 'InputSelect',
  props: {
    name: {
      type: String,
      default: () => ''
    },
    label: {
      type: String,
      default: () => null
    },
    unclickable: {
      type: Boolean,
      default: () => false
    },
    placeholder: {
      type: String,
      default: () => 'Selecione'
    },
    currentValue: {
      type: String,
      default: () => ''
    },
    handler: {
      type: String,
      default: () => null
    },
    groupIndex: {
      type: Number,
      default: () => null
    },
    index: {
      type: Number,
      default: () => null
    },
    items: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    set(selected) {
      const { groupIndex, items, index, handler, name } = this
      const item = items.find(({ id }) => id === selected) || { id: '', name: 'Selecione' }
      this.$emit('set', { name, item, groupIndex, index, handler })
    }
  }
}
</script>

<style lang="scss">

.select:not(.is-multiple):not(.is-loading)::after {
    border-color: #000000 !important;
}
</style>
